/**
 * Photos jointes à une note : l'ajout qui ne fabrique pas de doublon.
 *
 * Né de l'incident du 14/10/2026 : le dialogue QR relançait sa boucle
 * d'attente à chaque rendu, redemandait la session depuis le début et
 * rempilait les mêmes photos — 336 fois en quarante secondes, jusqu'à
 * 234 Mo de corps de requête refusés à la génération de la note. La boucle
 * est corrigée dans QRCaptureDialog ; cette fonction empêche le CONTENU de
 * s'empiler quand un même envoi est relu : une photo déjà jointe, reconnue
 * à son identifiant (celui que le serveur a donné à l'arrivée), n'est pas
 * rajoutée. Elle ne freine pas le DÉBIT des requêtes : ce n'est pas une
 * seconde ligne de défense contre une boucle, seulement contre ses dégâts.
 *
 * Deux détails voulus :
 *  - sans identifiant, une photo est toujours ajoutée (deux clichés d'un
 *    dépôt local ne doivent pas se confondre) ;
 *  - un PDF déjà joint SANS ses pages est complété si elles arrivent
 *    ensuite : la récupération des pages (/api/photo/pages) peut échouer au
 *    premier passage, et sans elles le modèle ne voit pas le document.
 */
export function ajouterPhotosRecues(precedentes, nouvelles, enPlus) {
  const liste = Array.isArray(precedentes) ? precedentes : [];
  if (!nouvelles || nouvelles.length === 0) return liste;

  // id → rang dans `liste`, ou -1 pour « ajoutée par ce lot-ci ».
  const rang = new Map();
  liste.forEach((p, i) => { if (p && p.id !== undefined && p.id !== null) rang.set(String(p.id), i); });

  let aJour = liste;   // recopié seulement si une entrée est complétée
  const ajouts = [];

  for (const photo of nouvelles) {
    if (!photo || !photo.data) continue;          // sans image, rien à joindre
    const id = photo.id || `${Date.now()}-${Math.random()}`;
    const cle = String(id);
    const dejaLa = rang.get(cle);

    if (dejaLa !== undefined) {
      const connue = dejaLa >= 0 ? aJour[dejaLa] : null;
      const pagesNeuves = photo.page_images && photo.page_images.length > 0;
      const pagesAbsentes = connue && !(connue.page_images && connue.page_images.length > 0);
      if (pagesNeuves && pagesAbsentes) {
        if (aJour === liste) aJour = [...liste];
        aJour[dejaLa] = {
          ...connue,
          is_pdf: true,
          page_count: photo.page_count,
          page_images: photo.page_images,
        };
      }
      continue;                                   // déjà dans la note
    }

    rang.set(cle, -1);
    ajouts.push({
      id,
      name: photo.name || 'photo_mobile.jpg',
      data: photo.data,
      ...(photo.is_pdf && {
        is_pdf: true,
        page_count: photo.page_count,
        page_images: photo.page_images,
      }),
      ...enPlus,
    });
  }

  if (ajouts.length === 0) return aJour;          // === liste si rien n'a bougé
  return [...aJour, ...ajouts];
}
